import { type TextProps, Text } from '@radix-ui/themes'
import * as React from 'react'

import { appConfig } from '#app/app-config.ts'
import { type Locale } from '#app/models/locale.ts'
import { testId } from '#app/utils/client/test-id.ts'

/* -------------------------------------------------------------------------------------------------
 * Price
 * -----------------------------------------------------------------------------------------------*/

enum TEST_IDS {
	price = 'price',
}

type PriceElement = React.ElementRef<typeof Text>
type PriceProps = TextProps & {
	children: number
	locale: Locale
}

const Price = React.forwardRef<PriceElement, PriceProps>(
	(props, forwardedRef) => {
		const { children, locale, ...rest } = props

		const price = React.useMemo(
			() =>
				new Intl.NumberFormat(locale, {
					style: 'currency',
					currency: appConfig.currency,
				}),
			[locale],
		)
		const formattedPrice = React.useMemo(
			() => price.format(children / 100),
			[price, children],
		)

		return (
			<Text ref={forwardedRef} {...rest} {...testId(TEST_IDS.price)}>
				{formattedPrice}
			</Text>
		)
	},
)
Price.displayName = 'Price'

/* -----------------------------------------------------------------------------------------------*/

export { type PriceProps, Price, TEST_IDS as PRICE_TEST_IDS }
